import merge from 'lodash/merge';

const CC_PAYMENT_ALLOWED_CODES = ['us', 'ca', 'uk', 'nz', 'au'];
const DEFAULT_LOCALE = 'en';

export default class User {
  static NAME = 'user';

  static getDetailsConfig = () => ({
    url: '/v1/users/details',
    dataPath: ['userProfileInfo']
  });

  constructor(user) {
    this.init(user);

    const userContactInfo = user?.userContactInfo || {};
    const roles = user?.userRoles || {};

    this.userId = userContactInfo.userId;
    this.userName = userContactInfo.userName;
    this.firstName = userContactInfo.firstName;
    this.lastName = userContactInfo.lastName;
    this.isSCMS = roles.scms;
    this.locale = user?.displayLang || DEFAULT_LOCALE;
    this.countryCode = userContactInfo.contactInfo?.country?.isoCode || '';
  }

  creditCardPaymentAllowed() {
    return CC_PAYMENT_ALLOWED_CODES.includes(this.countryCode.toLowerCase());
  }

  init(data) {
    merge(this, data);
  }
}
